import React from 'react';

const SvgYoutube = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    {...props}
  >
    <path
      d="M7.17143 6.075L10.5714 8.00714L7.17143 9.93929V6.075ZM16.5 1.71429V14.2857C16.5 15.2321 15.7321 16 14.7857 16H2.21429C1.26786 16 0.5 15.2321 0.5 14.2857V1.71429C0.5 0.767857 1.26786 0 2.21429 0H14.7857C15.7321 0 16.5 0.767857 16.5 1.71429ZM15 8.01071C15 8.01071 15 5.88214 14.7286 4.86071C14.5786 4.29643 14.1393 3.85357 13.5786 3.70357C12.5679 3.42857 8.5 3.42857 8.5 3.42857C8.5 3.42857 4.43214 3.42857 3.42143 3.70357C2.86071 3.85357 2.42143 4.29643 2.27143 4.86071C2 5.87857 2 8.01071 2 8.01071C2 8.01071 2 10.1393 2.27143 11.1607C2.42143 11.725 2.86071 12.15 3.42143 12.3C4.43214 12.5714 8.5 12.5714 8.5 12.5714C8.5 12.5714 12.5679 12.5714 13.5786 12.2964C14.1393 12.1464 14.5786 11.7214 14.7286 11.1571C15 10.1393 15 8.01071 15 8.01071Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgYoutube;
